// src/pages/admin/AdminAuditLog.js
// Was linked from the dashboard but never built — same "linked, never routed" gap as Skills.
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuditLog } from '../../lib/db';
import { format } from 'date-fns';
import { PageBack } from '../../components/shared/PageBack';

const AdminAuditLog = () => {
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAuditLog(100).then(e => { setEntries(e); setLoading(false); });
  }, []);

  const fmtDate = (ts) => {
    if (!ts) return '—';
    try { return format(ts?.toDate ? ts.toDate() : new Date(ts), 'd MMM yyyy · HH:mm'); }
    catch { return '—'; }
  };

  return (
    <div style={{ background: 'var(--cream)', minHeight: '100vh', padding: '52px 20px 40px' }}>
      <button onClick={() => navigate('/admin')} style={s.back}>
        <div style={s.backCircle}>←</div>
        <span style={s.backLbl}>Admin</span>
      </button>
      <div style={s.h1}>Audit Log</div>
      <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16 }}>Last 100 admin actions</p>

      {loading
        ? <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><div className="spinner" /></div>
        : entries.length === 0
          ? <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>No actions logged yet</div>
          : entries.map(entry => (
              <div key={entry.id} style={s.card}>
                <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--ink)' }}>{entry.action}</div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{fmtDate(entry.timestamp)}</div>
              </div>
            ))
      }
      <PageBack position="bottom" fallbackPath="/admin" />
    </div>
  );
};

const s = {
  back: { display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', marginBottom: 20 },
  backCircle: { width: 34, height: 34, background: 'var(--white)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, color: 'var(--sage-dark)', boxShadow: 'var(--shadow-sm)' },
  backLbl: { fontSize: 13, color: 'var(--muted)', fontWeight: 600 },
  h1: { fontSize: 26, fontWeight: 800, color: 'var(--ink)', marginBottom: 4 },
  card: { background: 'var(--white)', borderRadius: 12, padding: '10px 14px', marginBottom: 8, boxShadow: 'var(--shadow-sm)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
};

export default AdminAuditLog;
